import {User} from '../models/users/user.model';

export namespace Settings {
  export class UpdateExpansionPanel {
    static readonly type = '[Settings] Update Expansion Panels';

    constructor(public key: string, public enabled: boolean) {
    }
  }

  export class UpdateSearchColumns {
    static readonly type = '[Settings] Update Search Columns';

    constructor(public columns: string[]) {
    }
  }

  export class UpdateJobStatusColumns {
    static readonly type = '[Settings] Update Job Status Columns';

    constructor(public columns: string[]) {
    }
  }

  export class UpdateDarkMode {
    static readonly type = '[Settings] Update Dark Mode';

    constructor(public enabled: boolean) {
    }
  }

  export class UpdateStickyHeader {
    static readonly type = '[Settings] Update Sticky Header';

    constructor(public enabled: boolean) {
    }
  }
}
